import React from 'react'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import useUser from '../generic/hooks/useUser/useUser'
import { resolveGreeting, sessionDisplayName } from '../generic/utilities/greeting_utils'
import HeroSection from './HeroSection'
import ProductsSection from './ProductsSection'
import BrandBand from './BrandBand'
import './micHome.css'

/**
 * MIC static landing page (HU-01/HU-02/HU-03).
 *
 * Replaces the previous `/home` behaviour, where the route mounted the Monitoring screen
 * (`MonitoringScreenByGroup`) and the user landed straight in a single tool with no cover
 * presenting the platform.
 *
 * The page is static by design (R2): fixed content, no live data and no API calls, so it
 * renders identically for every user beyond the greeting. The one dynamic touch is the
 * time-of-day salutation, which reads the local clock only.
 *
 * The reference design's own sidebar is deliberately NOT ported: inside the app this page
 * mounts within `MainContainer`, whose `LeftMenu` already plays that role, and redesigning
 * the app chrome is out of scope for this story.
 */

const MicHome = () => {
  const { t_ } = useSmartTranslation()
  const { user } = useUser()

  // `user` is null while the session is being resolved or after logout, so the greeting
  // degrades to its impersonal form rather than assuming a name is there.
  const greetedName = sessionDisplayName(user)
  const greeting = resolveGreeting(t_, new Date().getHours(), greetedName)

  return (
    <div className='mic-home'>
      <HeroSection greeting={greeting} />
      <ProductsSection />
      <BrandBand />
    </div>
  )
}

export default MicHome
